import React, { useState, useMemo } from "react";
import ReactSelect from "react-select";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import { isDuplicateSkill } from "../../../../../utils/skillUtils";
import { urtoast } from "../../../../Layouts/CustomPopup/eventEmitter";

export default function ICustomAddSkills({
  formik,
  popularSkills = [],
  allSkills = [],
}) {
  const [addmanual, setAddmanual] = useState(false);
  const [manualSkill, setManualSkill] = useState("");

  // Use formik.values.skills directly as the source of truth
  const selectedSkills = useMemo(() =>
    Array.isArray(formik.values.skills) ? formik.values.skills : []
    , [formik.values.skills]);

  // ✅ Dropdown skill selection
  const handleLanguageChange = (selectedOption) => {
    if (!selectedOption) return;

    if (isDuplicateSkill(selectedOption.value, selectedSkills)) {
      urtoast("Duplicate Skill Not Allowed", 2);
      return;
    }

    const newSkill = {
      id: selectedOption.value,
      title: selectedOption.label,
    };

    formik.setFieldValue("skills", [...selectedSkills, newSkill]);
  };

  // ✅ Add popular skill
  const handleAddPopularSkill = (skill) => {
    if (isDuplicateSkill(skill.id, selectedSkills)) {
      urtoast("Duplicate Skill Not Allowed", 2);
      return;
    }

    formik.setFieldValue("skills", [...selectedSkills, { id: skill.id, title: skill.title }]);
  };

  // ✅ Delete skill
  const handleDeleteLanguage = (id) => {
    const updated = selectedSkills.filter((s) => s.id !== id);
    formik.setFieldValue("skills", updated);
  };

  // ✅ Add manual skill
  const handleAddManualSkill = () => {
    const trimmed = manualSkill.trim();
    if (!trimmed) return;

    const duplicate =
      isDuplicateSkill(trimmed, selectedSkills) ||
      (Array.isArray(allSkills) &&
        allSkills.some(
          (skill) => skill.title.toLowerCase() === trimmed.toLowerCase()
        ));

    if (duplicate) {
      urtoast("Duplicate Skill Not Allowed", 2);
      return;
    }

    const newSkill = { id: trimmed, title: trimmed };
    formik.setFieldValue("skills", [...selectedSkills, newSkill]);
    setManualSkill("");
    setAddmanual(false);
  };

  return (
    <div>
      {/* ✅ Popular Skills */}
      <div className="popular-skill form-group">
        <h5>
          Competencies Suggestions <AsteriskLabel />
        </h5>
        <div className="add-skills">
          {Array.isArray(popularSkills) &&
            popularSkills
              .filter((skill) => !isDuplicateSkill(skill.id, selectedSkills))
              .map((skill, index) => (
                <div key={index} onClick={() => handleAddPopularSkill(skill)}>
                  <p>
                    {skill.title} <span>+</span>
                  </p>
                </div>
              ))}
        </div>
      </div>

      {/* ✅ Selected Skills Section */}
      <div className="form-group skill-sec">
        <h5 className="skill-right">Add competencies</h5>

        <div className="add-skills skill-margin">
          {selectedSkills.map((skill, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skill.id)}>
                {skill.title} <span>x</span>
              </p>
            </div>
          ))}
        </div>

        {formik.touched.skills && formik.errors.skills && (
          <p style={{ color: "red" }}>{formik.errors.skills}</p>
        )}

        {/* ✅ Dropdown */}
        <div className="skill-img">
          <button className="btn skill-img-btn" type="button">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/select-icon.svg`}
              alt=""
            />
          </button>

          <ReactSelect
            options={
              Array.isArray(allSkills)
                ? allSkills
                  .filter((s) => !isDuplicateSkill(s.id, selectedSkills))
                  .map((s) => ({ value: s.id, label: s.title }))
                : []
            }
            placeholder="Select competencies"
            isClearable
            // Explicitly set value to null to prevent it becoming a controlled component
            // with a value that doesn't change unless we want it to.
            value={null}
            onChange={(option) => handleLanguageChange(option)}
          />
        </div>

        {/* ✅ Manual Skill Input */}
        <button
          className="add-plus btn"
          type="button"
          onClick={() => setAddmanual(true)}
        >
          + Add competencies Manually
        </button>

        {addmanual && (
          <div className="manualskill-input">
            <input
              type="text"
              value={manualSkill}
              onChange={(e) => setManualSkill(e.target.value)}
              style={{ width: "70%" }}
              placeholder="Type a competency"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAddManualSkill();
                }
              }}
            />
            <button type="button" onClick={handleAddManualSkill}>
              Add
            </button>
            <button type="button" onClick={() => setAddmanual(false)}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
